import DesignA from './design-a/DesignA';

function App() {
  return <DesignA />;
}

export default App;
